import moment from 'moment/moment';

import { DATE_REQUEST_FORMAT_WITH_SLASH_DELIMITER } from 'utilities/dates_and_times';

export const buildSubmittedUserLabel = (user, createdAt) => {
  const submittedUser = user ? `by ${user.first_name} ${user.last_name}` : '';

  const dateFormatted = moment(createdAt).format(
    DATE_REQUEST_FORMAT_WITH_SLASH_DELIMITER,
  );

  return `${dateFormatted} ${submittedUser}`;
};
